import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/C4';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getInfoC4() {
    return get(`${url}/info`);
}

export function submitC4(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
